import ChannelService from '@/composables/communication/channelTalkService.client'

export const useChannelTalk = () => {
  const config = useRuntimeConfig()
  const booted = useState('channelTalk:booted', () => false)
  const visible = useState('channelTalk:visible', () => false)

  const applyVisibility = () => {
    if (process.server || !booted.value) return
    window.ChannelIO?.(visible.value ? 'showChannelButton' : 'hideChannelButton')
  }

  const startChannelTalk = () => {
    if (process.server || booted.value) return
    const channelTalk = new ChannelService()
    channelTalk.boot(
      {
        pluginKey: `${config.public.channelIoPluginKey}`,
        mobileMessengerMode: 'iframe',
        zIndex: 2000,
        hideChannelButtonOnBoot: true
      },
      (error) => {
        if (error) return
        booted.value = true
        applyVisibility()
      }
    )
  }

  const showChannelTalk = () => {
    if (process.server) return
    visible.value = true
    applyVisibility()
  }

  const hideChannelTalk = () => {
    if (process.server) return
    visible.value = false
    applyVisibility()
  }

  return {
    startChannelTalk,
    showChannelTalk,
    hideChannelTalk
  }
}
